import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';

const AkoToFungujeCreditor = ({ t }) => (
  <PagesLayout className="ako-to-funguje">
    <h1>{t('Ako investovať')}</h1>
    <p>
      {t(
        'Ide o moderné informačné riešenie umožňujúce stretnutie dlžníka a investora. Základný princíp je v požičiavaní peňazí od investorov, ktorí ich majú navyše, k dlžníkom, ktorým peniaze naopak chýbajú, pričom jeden investor môže požičať peniaze naraz niekoľkým dlžníkom, čím sa výrazne zníži riziko nesplatenia úveru. Ide o komunitné investovanie alebo kolektívne požičiavanie v rámci ktorého vystupujú spravidla tri subjekty:'
      )}
    </p>
    <ul className="disc">
      <li>{t('dlžník, ktorý si požičiava,')}</li>
      <li>{t('veriteľ (investor), ktorý poskytuje finančné prostriedky dlžníkovi,')}</li>
      <li>{t('internetová platforma, kde sa títo dvaja nájdu.')}</li>
    </ul>
  </PagesLayout>
);

AkoToFungujeCreditor.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(AkoToFungujeCreditor);



// WEBPACK FOOTER //
// ./src/features/pages/AkoToFungujeCreditor.js